import { VideoPlayer } from '@helpers/VideoPlayer';

class YoutubeVideo extends VideoPlayer {
  constructor(iframe: HTMLIFrameElement) {
    super(new window.YT.Player(iframe));
  }

  onPlayVideo() {
    this?._player?.playVideo();
  }

  onPauseVideo() {
    if (typeof this?._player?.pauseVideo === 'function') {
      this?._player?.pauseVideo();
    }
  }

  onStopVideo() {
    this?._player?.stopVideo();
  }
}

export { YoutubeVideo };
